import { SortableContext } from "@dnd-kit/sortable";

import { cn } from "@/lib/chillnn/cn";

import { Button } from "@/components/ui/button/button";
import EditDocument from "@/components/ui/icon/edit-document";

import { SelectedSNSIconsItem } from "./item";

import type { SnackBlocksFormModelMethodsType } from "../../../../../../model/usecase/use-create-snack-layout-settings-form-model/methods";

type Props = {
	snsIcons: SnackBlocksFormModelMethodsType["SNSMethods"]["snsIcons"];
	snsColor: SnackBlocksFormModelMethodsType["SNSMethods"]["snsColor"];
	activateModal: SnackBlocksFormModelMethodsType["SNSMethods"]["activateModal"];
};

export const SelectedSNSIcons = ({ snsIcons, snsColor, activateModal }: Props) => {
	return (
		<div className="relative flex w-[90%] items-center justify-center rounded border border-white py-2">
			{/* @dnd-kit/sortable を使って DnD を実装している */}
			<SortableContext
				items={snsIcons.value.map(
					(item) => item.snsType.value, // id が存在していないので、snsType を使っている
				)}
			>
				<div className={cn("flex w-1/2 justify-center", snsIcons.value.length === 1 && "space-x-32")}>
					{snsIcons.value.map((snsIcon) => {
						if (!snsIcon.selected.value) return null;

						return (
							<SelectedSNSIconsItem
								key={snsIcon.snsType.value}
								snsColor={snsColor}
								snsIcon={snsIcon}
								snsIcons={snsIcons}
								activateModal={activateModal}
							/>
						);
					})}
				</div>
			</SortableContext>

			<Button
				className="absolute right-2"
				type="button"
				onClick={activateModal}
				tooltip="アイコンの色、表示・非表示、URL設定"
				variant="input-ish"
				size="icon"
			>
				<EditDocument />
			</Button>
		</div>
	);
};

SelectedSNSIcons.displayName = "SelectedSNSIcons";
